import React from 'react'
import Select from 'live/components/forms/ui/select'
import usePerspective from '../hooks/usePerspective'

interface PerspectiveSelectProps {
    label: string
    value: number
    required?: boolean
    onChange: (value: number) => void
}

const PerspectiveSelect: React.VFC<PerspectiveSelectProps> = ({ value, label, required, onChange }) => {
    const { perspectives } = usePerspective()

    const options = !perspectives
        ? []
        : perspectives.map((item: any) => ({
              value: item.id?.toString(),
              label: item.name
          }))

    return (
        <Select
            label={label}
            required={required}
            value={value?.toString()}
            onChange={onChange}
            clearable={false}
            options={options}
            searchable={options.length > 5}
        />
    )
}

export default React.memo(PerspectiveSelect)
